import React from "react";

function Kunsthandwerk() {
    return (
        <div class="uk-container uk-padding">
            <h2>Kunsthandwerkverkauf</h2>
            <div class="uk-text-left">
            <p>Meine handwerklichen und künstlerischen Objekte könnt Ihr direkt vor Ort kaufen.</p>
            <p>Der Besuch in meiner Werkstatt ist nach <a href="tel:+4944885204588">telefonischer Absprache</a> möglich.</p>
            <p>Einen Einblick in meine Arbeiten bekommt Ihr in der <a href="/gallery">Galerie.</a> </p>
            </div>
        </div>
    );
}

export default Kunsthandwerk;